import { render, staticRenderFns } from "./Launcher.vue?vue&type=template&id=f3b4f27c&scoped=true"
import script from "./Launcher.vue?vue&type=script&lang=js"
export * from "./Launcher.vue?vue&type=script&lang=js"
import style0 from "./Launcher.vue?vue&type=style&index=0&id=f3b4f27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b4f27c",
  null
  
)

export default component.exports